import React, { Component } from "react";
import { Icon } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import styles from "./styles.module.scss";
import clsx from "clsx";
import Ripple from "./Component/Ripple";
import localStorageService from "app/services/localStorageService";

class EgretVerticalNavExpansionPanel extends Component {
  elementRef = React.createRef();

  componentHeight = 0;

  handleClick = () => {
    let { currentOpen, handleCurrentOpen, item, history } = this.props;
    if (currentOpen === item?.name) {
      handleCurrentOpen("")
    } else {
      handleCurrentOpen(item?.name);
      if (localStorageService.getMenuOpenFirstChild() && 
      item?.children?.[0]?.path) {
        history.push(item?.children?.[0]?.path)
      }
    }
  };

  calcaulateHeight(node) {
    if (node.name !== "child") {
      for (let child of node.children) {
        this.calcaulateHeight(child);
      }
    }
    this.componentHeight += node.clientHeight;
    return;
  }
  componentDidMount() {
    let { location, handleCurrentOpen, item } = this.props;
    this.calcaulateHeight(this.elementRef);

    // OPEN DROPDOWN IF CHILD IS ACTIVE
    for (let child of this.elementRef.children) {
      if (child.getAttribute("href") === location.pathname) {
        handleCurrentOpen(item?.name);
      }
    }
  }

  render() {
    let { children, currentOpen } = this.props;
    let { name, icon, badge } = this.props.item;
    const { t } = this.props;
    const open = currentOpen === name

    return (
      <div>
        <button
          className={clsx(styles["touch-ripple"], "nav-item flex-middle h-48 w-100")}
          onClick={this.handleClick}
        >
          <div className="d-flex left">
            <Icon className="text-middle item-icon">{icon}</Icon>
            <span className={clsx("text-middle item-text", !!icon && "pl-8")}>{t(name)}</span>
          </div>
          {badge && (
            <div className={`badge bg-${badge.color}`}>{badge.value}</div>
          )}
          <div
            className={
              open
                ? styles.expandIcon + " item-arrow"
                : styles.collapseIcon + " item-arrow"
            }
          >
            <Icon className="text-middle">chevron_right</Icon>
          </div>
          <Ripple />
        </button>

        <div
          ref={(el) => (this.elementRef = el)}
          className={styles["expansion-panel"] + " submenu"}
          style={
            open
              ? { maxHeight: this.componentHeight + "px" }
              : { maxHeight: "0px" }
          }
        >
          {children}
        </div>
      </div>
    );
  }
}

export default withRouter(EgretVerticalNavExpansionPanel);
